function paintStart(line) {
    const firstMeasured = line.words.find((word) => (word.timingSource === "pixel" || word.timingSource === "pixel-retimed")
        && Number.isFinite(word.startTime));
    return firstMeasured ? Number(firstMeasured.startTime) : Number(line.startTime);
}
function rowCenter(line) {
    var _a;
    return ((_a = line.bbox) === null || _a === void 0 ? void 0 : _a.length) === 4 ? (line.bbox[1] + line.bbox[3]) / 2 : 0;
}
function sameRow(a, b) {
    var _a, _b;
    if (((_a = a.bbox) === null || _a === void 0 ? void 0 : _a.length) !== 4 || ((_b = b.bbox) === null || _b === void 0 ? void 0 : _b.length) !== 4)
        return !a.bbox && !b.bbox;
    const overlap = Math.max(0, Math.min(a.bbox[3], b.bbox[3]) - Math.max(a.bbox[1], b.bbox[1]));
    const shorterHeight = Math.min(a.bbox[3] - a.bbox[1], b.bbox[3] - b.bbox[1]);
    const horizontal = Math.max(0, Math.min(a.bbox[2], b.bbox[2]) - Math.max(a.bbox[0], b.bbox[0]));
    const shorterWidth = Math.min(a.bbox[2] - a.bbox[0], b.bbox[2] - b.bbox[0]);
    return shorterHeight > 0 && shorterWidth > 0
        && overlap >= shorterHeight * 0.5 && horizontal >= shorterWidth * 0.5;
}

/** Lines used for on-video karaoke paint, including image-read lyrics. */
export function paintRows(lines) {
    return (lines || []).filter((line) => !line.supersededBy && !line.nonLyricOverlay
        && (line.evidenceClass == null || line.evidenceClass === "confirmed_lyric"
            || line.autoImageLyric === true));
}

export function activeRows(lines, now) {
    const active = lines.filter((line) => {
        var _a;
        return now >= Number((_a = line.displayStartTime) !== null && _a !== void 0 ? _a : line.startTime)
            && now <= Number(line.endTime);
    });
    const rows = [];
    for (const line of active) {
        const row = rows.find((candidates) => sameRow(candidates[0], line));
        if (row)
            row.push(line);
        else
            rows.push([line]);
    }
    return rows.sort((a, b) => rowCenter(a[0]) - rowCenter(b[0])).map((candidates) => {
        var _a;
        // A new white lyric row can appear while the previous row is still
        // being painted. Prefer the row whose paint has actually begun; only
        // use display time when no candidate has started painting yet.
        const painting = candidates.filter((line) => paintStart(line) <= now);
        const eligible = painting.length ? painting : candidates;
        eligible.sort((a, b) => {
            var _a, _b;
            return (painting.length
                ? paintStart(b) - paintStart(a)
                : Number((_a = b.displayStartTime) !== null && _a !== void 0 ? _a : b.startTime) - Number((_b = a.displayStartTime) !== null && _b !== void 0 ? _b : a.startTime));
        });
        const latest = eligible[0];
        const terms = (line) => line.words.map((word) => word.text.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        const latestTerms = terms(latest);
        const duplicates = eligible.filter((line) => {
            var _a, _b;
            const other = terms(line);
            const matching = latestTerms.filter((term, index) => term === other[index]).length;
            return Math.abs(Number((_a = line.displayStartTime) !== null && _a !== void 0 ? _a : line.startTime) - Number((_b = latest.displayStartTime) !== null && _b !== void 0 ? _b : latest.startTime)) < 6
                && matching / Math.max(latestTerms.length, other.length, 1) >= 0.65;
        });
        return (_a = duplicates.sort((a, b) => {
            const measured = (line) => line.words.filter((word) => word.timingSource === "pixel-retimed" || word.timingSource === "pixel").length;
            const paintOrder = paintStart(b) - paintStart(a);
            // Once a new paint cycle starts, an older fully measured cycle must
            // never win merely because it has more pixel-labelled words.
            if (painting.length && Math.abs(paintOrder) > 0.2)
                return paintOrder;
            return measured(b) - measured(a) || paintOrder;
        })[0]) !== null && _a !== void 0 ? _a : latest;
    });
}
